export interface KillEvent {
  killerName: string;
  victimName: string;
  weapon: string;
  timestamp: number;
}

export class KillFeed {
  private container: HTMLElement;
  private events: KillEvent[] = [];
  private maxEvents: number = 5;
  private renderTimer: ReturnType<typeof setTimeout> | null = null;

  constructor(container: HTMLElement) {
    this.container = container;
    this.addStyles();
  }

  addKill(killer: string, victim: string, weapon: string): void {
    this.events.unshift({
      killerName: killer,
      victimName: victim,
      weapon,
      timestamp: Date.now(),
    });

    if (this.events.length > this.maxEvents) {
      this.events.pop();
    }

    this.render();

    // Schedule re-render after 5 seconds to hide old events
    if (this.renderTimer) {
      clearTimeout(this.renderTimer);
    }
    this.renderTimer = setTimeout(() => this.render(), 5000);
  }

  render(): void {
    const now = Date.now();
    const recentEvents = this.events.filter((e) => now - e.timestamp < 5000);

    if (recentEvents.length === 0) {
      this.container.innerHTML = '';
      return;
    }

    this.container.innerHTML = recentEvents
      .map(
        (e) => `
      <div class="kill-event">
        <span class="killer">${this.escapeHtml(e.killerName)}</span>
        <span class="weapon">[${this.escapeHtml(e.weapon)}]</span>
        <span class="victim">${this.escapeHtml(e.victimName)}</span>
      </div>
    `,
      )
      .join('');
  }

  private escapeHtml(text: string): string {
    const div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  }

  private addStyles(): void {
    if (document.getElementById('kill-feed-styles')) return;

    const style = document.createElement('style');
    style.id = 'kill-feed-styles';
    style.textContent = `
      #kill-feed-container {
        position: fixed;
        top: 80px;
        right: 20px;
        z-index: 100;
        pointer-events: none;
      }
      
      .kill-event {
        background: rgba(0, 0, 0, 0.8);
        padding: 8px 12px;
        margin-bottom: 4px;
        border-radius: 4px;
        font-size: 14px;
        color: white;
        animation: slideIn 0.3s ease-out;
        display: flex;
        gap: 6px;
        align-items: center;
      }
      
      .kill-event .killer {
        color: #ff4444;
        font-weight: bold;
      }
      
      .kill-event .weapon {
        color: #ffaa00;
        font-size: 12px;
      }
      
      .kill-event .victim {
        color: #aaaaaa;
      }
      
      @keyframes slideIn {
        from {
          transform: translateX(100%);
          opacity: 0;
        }
        to {
          transform: translateX(0);
          opacity: 1;
        }
      }
    `;
    document.head.appendChild(style);
  }

  destroy(): void {
    if (this.renderTimer) {
      clearTimeout(this.renderTimer);
    }
    this.container.innerHTML = '';
  }
}
